var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ParamWrapper',_vm._b({},'ParamWrapper',_vm.wrapperProps,false),[_c('TableFilterConditionGenerator',{attrs:{"param":_vm.param,"node":_vm.node,"rules":_vm.localValue || undefined,"readonly":_vm.readonly},on:{"onChange":_vm.onRulesChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }